import {FFmpeg} from "@ffmpeg/ffmpeg";

export const FFMPEG_CORE_BASE_URL = "https://cdn.jsdelivr.net/npm/@ffmpeg/core@0.12.10/dist/umd";

export async function loadFFmpeg(onLog?: (message: string) => void) {
    const ffmpeg = new FFmpeg();

    if (onLog) {
        ffmpeg.on("log", ({message}) => onLog(message));
    }

    await ffmpeg.load({
        coreURL: `${FFMPEG_CORE_BASE_URL}/ffmpeg-core.js`,
        wasmURL: `${FFMPEG_CORE_BASE_URL}/ffmpeg-core.wasm`
    });

    return ffmpeg;
}
